"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var XoneTestResulset_1 = require("../Test/XoneTestResulset");
var XoneConnectionData_1 = require("../XoneConnectionData");
var XoneJSONConnection_1 = require("./XoneJSONConnection");
var XoneJSONConnectionData = /** @class */ (function (_super) {
    __extends(XoneJSONConnectionData, _super);
    /**
     * Crea una conexión a base de datos
     *
     * @param Name  Nombre de la conexión.
     * @param Owner Aplicación a la cual pertenece esta conexión.
     */
    function XoneJSONConnectionData(context, Name, Owner) {
        var _this = _super.call(this, Name, Owner) || this;
        _this.m_context = context;
        return _this;
        // K11101001: Utilizar SESSIONID numérico para mejorar el rendimiento de la maquinaria.
        // this.m_nSessionIdCounter = new AtomicLong(0);
        // // A14011501: Optimizaciones para obtener claves numéricas de conexiones sqlite y demás.
        // this.m_nLastInsertedId = new ThreadLocal<>();
        // this.m_nLastRecordsAffected = new ThreadLocal<>();
        // this.m_strLastInsertedTable = new ThreadLocal<>();
        // // TODO ADD TAG
        // // Nos creamos el holder para el statement...
        // this.m_stmt = {}; // new ThreadLocal<>();
    }
    /**
     * TRUE si el DBMS soporta la sintaxis TOP x
     *
     * @return Esta función posiblemente no se redefina en esta plataforma.
     */
    XoneJSONConnectionData.prototype.TopAllowed = function () {
        return false;
    };
    /**
     * TRUE si el DBMS soporta la sintaxis LIMIT x
     *
     * @return Mirar arriba plis.
     */
    XoneJSONConnectionData.prototype.LimitAllowed = function () {
        return false;
    };
    /**
     * TRUE si la conexión tiene caracteres para escapear cadenas de caracteres.
     *
     * @return Devuelve TRUE si hay caracteres en la lista para sustituir.
     */
    XoneJSONConnectionData.prototype.HasEscapeChars = function () {
        return false;
    };
    /**
     * A11092601: Modificaciones para mejorar el soporte de conexiones remotas y demás.
     * Devuelve TRUE si la conexión acepta sentencias SQL parseadas para su ejecución o para queries.
     *
     * @return
     */
    XoneJSONConnectionData.prototype.acceptsParsedSentences = function () {
        return true;
    };
    XoneJSONConnectionData.prototype.acceptsEmptyQueries = function () {
        return false;
    };
    /**
     * A11092601: Modificaciones para mejorar el soporte de conexiones remotas y demás.
     * Devuelve TRUE si la conexión permite recuperar un ID autonumérico dado un ROWID.
     *
     * @return
     */
    XoneJSONConnectionData.prototype.retrievesAutonumericKeys = function () {
        return false;
    };
    /**
     * Obtiene una conexión física a la fuente de datos que encapsula esta clase. Es de obligatoria redefinición por los derivados de esta clase.
     *
     * @return Devuelve una nueva conexión de datos (o la misma si solo se emplea una)
     * @throws Exception
     */
    XoneJSONConnectionData.prototype.GetNewConnection = function (ReadOnly) {
        if (ReadOnly === void 0) { ReadOnly = false; }
        return this.m_connection = new XoneJSONConnection_1.default(this.getConnString(), this.getName());
    };
    XoneJSONConnectionData.prototype.GetCurrentConnection = function (ReadOnly) {
        if (ReadOnly === void 0) { ReadOnly = false; }
        if (this.m_connection)
            return this.m_connection;
        return this.GetNewConnection(ReadOnly);
    };
    /**
     * Crea un conjunto de datos sin conexión original. Para ello crea una local y la devuelve como
     * parte del conjunto que la cierra cuando lo cierran a él
     *
     * @param Sentence Sentencia SQL que se ejecuta para obtener el conjunto de datos.
     * @return Devuelve un conjunto de datos o NULL si algo falla.
     * @throws Exception
     */
    /// public CreateRecordset(Sentence:string): IResultSet {
    //     return this.CreateRecordset(null, Sentence);
    // }
    /**
     * A11092601: Modificaciones para mejorar el soporte de conexiones remotas y demás.
     * Ejecuta una sentencia SQL parseada que devuelve datos.
     *
     * @param Sentence
     * @return
     * @throws Exception
     */
    /// public CreateRecordset(Sentence:any): IResultSet{
    //     return this.CreateRecordset(null, Sentence);
    // }
    /**
     * Crea un objeto de acceso a datos (recordset) para leer los datos de un objeto
     *
     * @param Connection Conexión que se quiere usar para abrir la fuente de datos. NULL para crear una local y usarla solamente para esta función.
     * @param Sentence   Setencia SQL (SELECT) que se quiere ejecutar para abrir la fuente de datos.
     * @param MaxRows    Máximo de registros para no usar el que tiene por defecto la clase.
     * @return Devuelve el conjunto de datos creado o NULL si algo falla.
     * @throws Exception
     */
    /// public abstract CreateRecordset(Connection Connection, String Sentence, int MaxRows): IResultSet;
    /**
     * A11092601: Modificaciones para mejorar el soporte de conexiones remotas y demás.
     * Esta implementación permite la ejecución de sentencias SQL parseadas con anterioridad.
     *
     * @param Connection
     * @param Sentence
     * @param MaxRows
     * @return
     * @throws Exception
     */
    /// public abstract ResultSet CreateRecordset(Connection: IConnection | string, ...args?:any) throws Exception;
    /*
     * TODO ADD TAG 17042014: Luis Un recordset a partir de la clase de parametros
     */
    XoneJSONConnectionData.prototype.CreateRecordset = function (Connection) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return new XoneTestResulset_1.default(Connection);
        // if (typeof Connection == 'string' ) {
        //     return this.GetCurrentConnection().executeQuery(Connection as string);
        // }
        // return null;
    };
    /*
     * TODO ADD TAG 17042014: Luis Un recordset a partir de la clase de parametros
     */
    XoneJSONConnectionData.prototype.CreateRecordsetAsync = function (Connection) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var cn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof Connection == 'string')) return [3 /*break*/, 2];
                        cn = this.GetCurrentConnection();
                        return [4 /*yield*/, cn.executeQueryAsync.apply(cn, __spreadArrays([Connection], args))];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, null];
                }
            });
        });
    };
    /*
     * TODO ADD TAG 17042014: Luis Un recordset a partir de la clase de parametros
     */
    XoneJSONConnectionData.prototype.CountAsync = function (Connection) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(typeof Connection == 'string')) return [3 /*break*/, 2];
                        return [4 /*yield*/, (_a = this.GetCurrentConnection()).countAsync.apply(_a, __spreadArrays([Connection], args))];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2: return [2 /*return*/, null];
                }
            });
        });
    };
    /**
     * Crea un objeto de acceso a datos (recordset) para leer los datos de un objeto
     *
     * @param Connection Conexión que se quiere usar para abrir la fuente de datos. NULL para crear una local y usarla solamente para esta función.
     * @param Sentence   Setencia SQL (SELECT) que se quiere ejecutar para abrir la fuente de datos.
     * @return Devuelve el conjunto de datos creado o NULL si algo falla.
     * @throws Exception
     */
    //public abstract ResultSet CreateRecordset(Connection Connection, String Sentence) throws Exception;
    /**
     * A11092601: Modificaciones para mejorar el soporte de conexiones remotas y demás.
     * Ejecuta una sentencia SQL parseada que devuelve datos.
     *
     * @param conn
     * @param Sentence
     * @return
     * @throws Exception
     */
    /// public abstract ResultSet CreateRecordset(Connection conn, SqlParser Sentence) throws Exception;
    /**
     * Ejecuta una sentencia SQL dentro de la conexión que manipula este objeto. No lleva conexión física como parámetro porque crea una temporal, trabaja con ella y la cierra.
     * <p>
     * K11092601: ExecuteSqlString y similares deben devolver un objeto, que puede ser ResultSet.
     * Cambiar el tipo de resultado.
     *
     * @param Sentence Sentencia SQL que se quiere ejecutar.
     * @return Devuelve TRUE si la ejecución de la sentencia SQL es correcta.
     * @throws Exception
     */
    // public ExecuteSqlString(Sentence: string): any {
    //     return ExecuteSqlString(null, Sentence, true);
    // }
    /**
     * A10090601:	Incluir el mecanismo de réplica selectiva por colecciones a la maquinaria.
     * Ejecuta un SQL sin replicar
     * <p>
     * K11092601: ExecuteSqlString y similares deben devolver un objeto, que puede ser ResultSet.
     * Cambiar el tipo de resultado.
     */
    // public Object ExecuteLocalSqlString(String Sentence) throws Exception {
    //     return ExecuteSqlString(null, Sentence, false);
    // }
    /**
     * A11092601: Modificaciones para mejorar el soporte de conexiones remotas y demás.
     * Ejecuta una sentencia SQL parseada con réplica.
     * <p>
     * K11092601: ExecuteSqlString y similares deben devolver un objeto, que puede ser ResultSet.
     * Cambiar el tipo de resultado.
     *
     * @param Sentence
     * @return
     * @throws Exception
     */
    // public Object ExecuteParsedSql(SqlParser Sentence) throws Exception {
    //     return ExecuteParsedSql(null, Sentence, true);
    // }
    /**
     * Ejecuta una sentencia SQL dentro de la conexión que manipula este objeto.
     * A10090601:	Incluir el mecanismo de réplica selectiva por colecciones a la maquinaria.
     * Un parámetro para decir si replica.
     * <p>
     * K11092601: ExecuteSqlString y similares deben devolver un objeto, que puede ser ResultSet.
     * Cambiar el tipo de resultado
     *
     * @param Connection Conexión de datos que se quiere usar para ejecutar la sentencia. NULL para crear una temporal, ejecutar la sentencia y cerrarla.
     * @param Sentence   Sentencia SQL que se va a ejecutar.
     * @param Replicate  TRUE si replica.
     * @return Devuelve TRUE si la sentencia se ejecuta correctamente.
     * @throws SQLException
     * @throws Exception
     */
    XoneJSONConnectionData.prototype.ExecuteSqlString = function (Connection, Sentence, Replicate) {
        var args = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args[_i - 3] = arguments[_i];
        }
        return 0;
    };
    XoneJSONConnectionData.prototype.ExecuteSqlStringAsync = function (Connection, Sentence, Replicate) {
        var args = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args[_i - 3] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, (_a = this.GetCurrentConnection()).executeAsync.apply(_a, __spreadArrays([Sentence, 100], args))];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * A11092601: Modificaciones para mejorar el soporte de conexiones remotas y demás.
     * Esta implementación opcional permite ejecutar una sentencia SQL parseada en vez de una cadena SQL.
     * <p>
     * K11092601: ExecuteSqlString y similares deben devolver un objeto, que puede ser ResultSet.
     * Cambiar el tipo de resultado.
     *
     * @param Connection
     * @param Sentence
     * @param Replicate
     * @return
     * @throws SQLException
     * @throws Exception
     */
    XoneJSONConnectionData.prototype.ExecuteParsedSql = function (Connection, Sentence, Replicate) {
        var args = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args[_i - 3] = arguments[_i];
        }
        return 0;
    };
    XoneJSONConnectionData.prototype.ExecuteParsedSqlAsync = function (Connection, Sentence, Replicate) {
        var args = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args[_i - 3] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, (_a = this.GetCurrentConnection()).executeAsync.apply(_a, __spreadArrays([Sentence, 100], args))];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * Reemplaza el valor del operador específico dentro de la cadena SQL que se pasa como parámetro.
     *
     * @param Collection Colección con la que se está trabajando.
     * @param Sentence   Sentencia SQL o cadena en la cual se quiere sustituir el operador.
     * @param OperName   Nombre del operador que se quiere sustituir.
     * @return Devuelve la sentencia original con el operador sustituido.
     * @throws Exception
     */
    XoneJSONConnectionData.prototype.ReplaceCustomOper = function (Collection, Sentence, OperName) {
        return Sentence;
    };
    /**
     * Inserta una sentencia TOP dentro del SQL que se pasa como parámetro. Colocada aquí para mantener compatibilidad de interfaces
     * pero no se implementará en esta plataforma.
     *
     * @param Sentence Sentencia SQL que se quiere modificar.
     * @param Rows     Cantidad de filas que se quiere limitar en el TOP x o LIMIT x
     * @return La misma sentencia pasada como parámetro.
     */
    XoneJSONConnectionData.prototype.InsertTop = function (Sentence, Rows) {
        return Sentence;
    };
    /**
     * Dado un nombre de campo lo formatea usando los caracteres de inicio y fin de campo.
     *
     * @param FieldName Nombre del campo a formatear.
     * @return Devuelve el nombre del campo encerrado en sus secuencias de inicio y fin de campo.
     */
    XoneJSONConnectionData.prototype.QuoteFieldName = function (FieldName) {
        return FieldName;
    };
    /**
     * Dado un nombre de tabla u otro tipo de objeto de base de datos, lo devuelve formateado con su prefijo si este está definido.
     *
     * @param ObjectName Nombre de tabla u objeto en general de la base de datos para arreglar con el prefijo.
     * @return Devuelve el nombre de objeto ya desarrollado con su prefijo si aplica.
     */
    // public String FixObjectName(String ObjectName):string {
    //     return FixObjectName(ObjectName, null);
    // }
    /**
     * Dada una cadena sustituye los caracteres para los cuales se hayan definido secuencias de escape por dichas secuencias.
     *
     * @param Value Cadena en la cual se van a sustituir los caracteres por secuencias de escape.
     * @return Devuelve la cadena original con los caracteres sustituidos por sus secuencias de escape.
     */
    XoneJSONConnectionData.prototype.EscapeString = function (Value) {
        if (Value.startsWith('\''))
            return Value;
        return "'" + Value + "'";
    };
    /**
     * Genera un ROWID para la conexión actual. Emplea los criterios de número de tabla, MID, DBID, etc.
     *
     * @param TableName Nombre de la tabla para la cual se quiere generar el ROWID.
     * @return Devuelve un ROWID respetando los valores de réplica y el tamaño del campo ROWID.
     */
    //public GenerateRowId(TableName:string):string {return Guid.create().toString();}
    /**
     * Desarrolla el valor de un objeto y lo devuelve como cadena lista para insertar en un SQL o un filtro
     *
     * @param Value Valor que se quiere desarrollar. Se usará la máscara de fecha de la conexión.
     * @return CAdena representando el valor del objeto para escribir en una sentencia SQL o un filtro de datos.
     */
    // public DevelopObjectValue(Value:any):string {
    //     return DevelopObjectValue(Value, true);
    // }
    /**
     * Esta función se emplea para cerrar conexiones locales si es que las tiene. No necesariamente tiene por qué
     * usarse para terminar la clase, simplemente cuando se quiera cerrar o destruir los objetos locales.
     */
    XoneJSONConnectionData.prototype.Terminate = function () { };
    /**
     * Si el DBMS soporta left outer joins
     */
    XoneJSONConnectionData.prototype.IsOuterJoinSupported = function () { return false; };
    /**
     * A11092601: Modificaciones para mejorar el soporte de conexiones remotas y demás.
     * Devuelve una clave numérica dada una tabla y un ROWID. Permite abstraer la obtención de la clave autonumérica
     * en conexiones que no son offline.
     *
     * @param TableName
     * @param RowIdFieldName
     * @return
     * @throws Exception
     */
    XoneJSONConnectionData.prototype.RetrieveNumericKey = function (TableName, KeyName, RowIdFieldName, RowId) { return 0; };
    /**
     * A11092601: Modificaciones para mejorar el soporte de conexiones remotas y demás.
     * Esta función permite calcular si un ROWID es único dentro de la conexión de datos.
     *
     * @param tableName
     * @param RowID
     * @return
     * @throws Exception
     */
    XoneJSONConnectionData.prototype.isUniqueRowID = function (tableName, RowID) { return true; };
    // A11120701: Mecanismo para exponer el DBMS de una conexión.
    // Expone el tipo de DBMS que tiene debajo esta conexión. Obligatorio implementar.
    XoneJSONConnectionData.prototype.getDbmsTag = function () { return "OnlineJSON"; };
    ;
    return XoneJSONConnectionData;
}(XoneConnectionData_1.default));
exports.default = XoneJSONConnectionData;

//# sourceMappingURL=XoneJSONConnectionData.js.map
